var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKroer = function SvgKroer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.331 14.667h13.333m-1.346.006V12M2 9.333h8m-4 5.334v-2.5m4.007 2.493-8 .013-.007-9.96c0-.446.227-.86.593-1.106l2.667-1.78a1.33 1.33 0 0 1 1.48 0l2.667 1.78c.373.246.593.66.593 1.106zM13.332 8C12.6 8 12 8.6 12 9.333v1.334c0 .733.6 1.333 1.333 1.333.734 0 1.334-.6 1.334-1.333V9.333c0-.733-.6-1.333-1.334-1.333ZM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  })));
};
export default SvgKroer;